import React from "react";
import { Provider } from "react-redux";
import reducer from "./redux/locationsSelectorReducer";
import rootSaga from "./redux/locationsSelectorSagas";
import ErrorBoundary from "../../components/errorBoundary/errorBoundary";
import { createReduxStore } from "../../utils/createReduxStore";
import { TrackingContext } from "../tracking/TrackingContext";
import { LocationsSelectorModule } from "./LocationsSelectorModule";

const LocationsSelector = (props) => {
  const { notifications, short_url, organization_id, isCorporate } = props;

  // The store picker renders on every page (dashboard + org-settings), so it owns its own tracking
  // zone rather than relying on PageWithConfigurator. Filter tracking only fires in qa/production.
  const trackingEnabled = ["qa", "production"].includes(notifications?.env);

  return (
    <Provider store={createReduxStore(reducer, "locations", rootSaga)}>
      <ErrorBoundary moduleName="locationsSelector" {...notifications}>
        <TrackingContext.Provider value={{ pageName: null, enabled: trackingEnabled }}>
          <LocationsSelectorModule params={{ organization_id, short_url, isCorporate }} />
        </TrackingContext.Provider>
      </ErrorBoundary>
    </Provider>
  );
};

export default LocationsSelector;
